module.exports = __webpack_public_path__ + "img/home_care.80807315.png";